import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue'; // 引入搜索部门弹出框的组件

import departWindow from "./DepartWindow";
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import { addUser, editUser, queryUserRole, queryall, queryIdTree, getUserSite } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import { duplicateCheck, ajaxGetDictItems } from '@/api/api';
import MapGetPoint from '@/components/Map/MapGetPoint';
import { querySiteTree } from '@/api/api';
export default {
  name: 'RoleModal',
  components: {
    departWindow: departWindow,
    MapGetPoint: MapGetPoint
  },
  data: function data() {
    return {
      index: 1,
      siteStMap: {},
      siteStOptions: [],
      paragraphArr: {
        rows: 10,
        width: ['100%', '80%', '100%', '80%', '100%', '80%', '100%', '80%', '100%', '80%']
      },
      showit: false,
      expandState: false,
      expandedKeys: [],
      current: 1,
      defaultValue: 1,
      defaultProps: [],
      lastUserSiteIds: [],
      //之前选中的站点id
      checkedKeys: [],
      //选中列表
      treeData: [],
      selected: 0,
      tabList: [{
        name: '基础信息'
      }, {
        name: '站点授权'
      }],
      departDisabled: false,
      //是否是我的部门调用该页面
      roleDisabled: false,
      //是否是角色维护调用该页面
      departTreeData: [],
      departId: '',
      postList: [],
      mapCenter: [],
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [],
      //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [],
      // 保存部门的名称 =>title
      checkedDepartNameString: '',
      // 保存部门的名称 =>title
      tenantList: [],
      userId: '',
      //保存用户id
      disableSubmit: false,
      userDepartModel: {
        userId: '',
        departIdList: []
      },
      // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD',
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: '请输入用户账号!'
          }, {
            validator: this.validateUsername
          }]
        },
        password: {
          rules: [{
            required: true,
            pattern: /^([A-Za-z0-9]{8,20})$/,
            message: '密码由8位或8位以上组成!'
          }, {
            validator: this.validateToNextPassword
          }]
        },
        confirmpassword: {
          rules: [{
            required: true,
            message: '请重新输入登录密码!'
          }, {
            validator: this.compareToFirstPassword
          }]
        },
        realname: {
          rules: [{
            required: true,
            message: '请输入用户名称!'
          }]
        },
        phone: {
          rules: [{
            validator: this.validatePhone
          }]
        },
        email: {
          rules: [{
            validator: this.validateEmail
          }]
        },
        roles: {} //  sex:{initialValue:((!this.model.sex)?"": (this.model.sex+""))}

      },
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 4
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 17
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 6
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 15
        }
      },
      showState: false,
      firststate: false,
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      picUrl: '',
      paramList: [],
      defaultSuffix: '',
      tenantIdValue: 0,
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['imgDomainURL'],
        userWithDepart: '/sys/user/userDepartList',
        // 引入为指定用户查看部门信息需要的url
        userWithPost: '/sys/user/post/find',
        // 获取用户选中的岗位类型
        userId: '/sys/user/generateUserId',
        // 引入生成添加用户情况下的url
        post: '/sys/post/find/',
        //加载岗位url
        config: '/sys/config/find/',
        userParams: '/sys/param/find/',
        syncUserByUserName: '/process/extActProcess/doSyncUserByUserName',
        //同步用户到工作流
        queryDefaultSuffix: '/sys/user/queryDefaultSuffix',
        // 获取用户默认密码尾缀
        queryAllTenant: '/sys/tenant/queryAllTenant' //查询所有的租户

      }
    };
  },
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.tenantIdValue = window.localStorage.getItem('tenant') ? window.localStorage.getItem('tenant') : 0;
    this.headers = {
      'X-Access-Token': token
    };
    this.getDict();
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    getDict: function getDict(code, name) {
      var _this = this;

      getAction('/site/sys/type', {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      }).then(function (res) {
        if (res.success) {
          res.result.records.forEach(function (item) {
            item.value = item.code;
            item.label = item.name;
            _this.siteStMap[item.value] = item;
          });
        }
      });
    },
    selectedTenant: function selectedTenant(index) {
      var isClear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      console.log('model', index);
      var selected = this.tenantList.find(function (item) {
        return item.id == index;
      });
      var selectedTenantId = index ? index : 0;
      isClear ? this.form.setFieldsValue({
        st: null
      }) : '';
      this.getDataFromTenant(selectedTenantId);
      console.log('index', selected);
    },
    getDataFromTenant: function getDataFromTenant(tenantId) {
      var _this2 = this;

      getAction("/sys/tenant/".concat(tenantId)).then(function (res) {
        if (res.success) {
          if (res.result.st != null) {
            var arr = res.result.st.split(',');
            _this2.siteStOptions = [];
            arr.forEach(function (item) {
              console.log(item, _this2.siteStMap[item]);

              _this2.siteStOptions.push(_this2.siteStMap[item]);
            });
            console.log('siteStOptions', _this2.siteStOptions);
          }

          _this2.index++;
        }
      });
    },
    loadAllTenant: function loadAllTenant() {
      var that = this;
      that.tenantList = [];
      getAction(that.url.queryAllTenant).then(function (res) {
        if (res.success) {
          that.tenantList = res.result;
        }
      });
    },
    checkALL: function checkALL() {
      var _this3 = this;

      this.checkedKeys = this.expandedKeys;
      this.showit = false;
      this.$nextTick(function () {
        _this3.showit = true;
      });
    },
    cancelCheckALL: function cancelCheckALL() {
      var _this4 = this;

      this.checkedKeys = [];
      this.showit = false;
      this.$nextTick(function () {
        _this4.showit = true;
      });
    },
    expandAll: function expandAll() {
      var _this5 = this;

      this.expandState = true;
      this.showit = false;
      this.$nextTick(function () {
        _this5.showit = true;
      });
    },
    closeAll: function closeAll() {
      var _this6 = this;

      this.expandState = false;
      this.showit = false;
      this.$nextTick(function () {
        _this6.showit = true;
      });
    },
    onChange: function onChange(data) {
      this.current = data.target.value;
      this.getTreeData();
    },
    onCheck: function onCheck(data) {
      var selectedArr = [];
      var arr = this.$refs.tree.getCheckedNodes();
      arr.forEach(function (item, index) {
        if (item.children == null) {
          selectedArr.push(item.data.id);
        }
      });
      this.checkedKeys = selectedArr; // this.$refs.tree.getCheckedKeys().join(',')
    },
    getDisabledList: function getDisabledList(arr) {
      var _this7 = this;

      var arrs = [];
      var arrData = JSON.parse(JSON.stringify(arr));
      arr.forEach(function (item1, index1) {
        item1.disabled = true;
        arrs.push(item1);

        if (item1.children && item1.children.length > 0) {
          item1.children = _this7.getDisabledList(item1.children);
        }
      });
      return arrs;
    },
    getKeyList: function getKeyList(arr) {
      var _this8 = this;

      arr.forEach(function (item1, index1) {
        if (item1.children && item1.children.length > 0) {
          _this8.getKeyList(item1.children);
        } else {
          _this8.expandedKeys.push(item1.key);
        }
      });
    },
    // 获取该用户配置的站点树的选择项
    getUserSelected: function getUserSelected(res1) {
      var _this9 = this;

      getUserSite({
        userId: this.userId
      }).then(function (res) {
        if (res.success) {
          _this9.showit = false;
          _this9.checkedKeys = res.result;
          _this9.lastUserSiteIds = res.result;

          _this9.$nextTick(function () {
            _this9.showit = true;

            _this9.getUserData(res1);
          });
        }
      });
    },
    getUserData: function getUserData(res) {
      if (this.disableSubmit) this.defaultProps = this.getDisabledList(res.result);else this.defaultProps = res.result;
    },
    getTreeData: function getTreeData() {
      var _this10 = this;

      var addrType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.treeData = [];
      this.showState = false;
      querySiteTree({
        addrType: this.current,
        all: true // st,

      }).then(function (res) {
        if (res.success) {
          _this10.showState = true;
          _this10.treeData = res.result; // res.result.forEach((item,index)=>{
          // 	item.disabled = true
          // 	item.children.forEach((item1,index1)=>{
          // 		item1.disabled = true
          // 		item1.children.forEach((item2,index2)=>{
          // 			item2.disabled = true
          // 		})
          // 	})
          // 	this.defaultProps.push(item)
          // })

          _this10.lastUserSiteIds = [];
          _this10.checkedKeys = [];
          _this10.expandedKeys = [];
          if (_this10.userId) _this10.getUserSelected(res);else _this10.getUserData(res);

          _this10.getKeyList(res.result);
        }
      });
    },
    ontoTab: function ontoTab(index) {
      this.selected = index;
    },
    isDisabledAuth: function isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    //窗口最大化切换
    toggleScreen: function toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }

      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    initialRoleList: function initialRoleList() {
      var _this11 = this;

      queryall().then(function (res) {
        if (res.success) {
          _this11.roleList = res.result;
        } else {}
      });
    },
    loadUserRoles: function loadUserRoles(userid) {
      var _this12 = this;

      queryUserRole({
        userid: userid
      }).then(function (res) {
        console.log('userid', res);

        if (res.success) {
          _this12.selectedRole = res.result;
        }
      });
    },
    loadDepartTree: function loadDepartTree() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          console.log('departTreeData', res);
          that.departTreeData = res.result;
        }
      });
    },
    //部门选择事件
    onTreeSelect: function onTreeSelect(selectedKeys) {
      this.$forceUpdate();
      this.postList = '';
      this.departId = selectedKeys;
      this.model.postId = undefined;
      this.loadPostList(selectedKeys);
      console.log('postId', this.model);
    },
    //获取岗位信息
    loadPostList: function loadPostList(params) {
      var _this13 = this;

      if (!params) {
        return;
      }

      console.log('params', params);
      getAction(this.url.post + params).then(function (res) {
        if (res.success) {
          _this13.postList = res.result;
        }
      });
    },
    //岗位切换事件
    handlePostChange: function handlePostChange(value) {
      console.log('value', value);
      this.model.postId = value;
    },
    refresh: function refresh() {
      this.selectedDepartKeys = [];
      this.checkedDepartKeys = [];
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.userId = '';
    },
    add: function add() {
      this.picUrl = '';
      this.refresh();
      this.edit({
        activitiSync: '1'
      });
    },
    edit: function edit(record) {
      var _this14 = this;

      this.expandState = false;
      this.showit = false;
      this.$nextTick(function () {
        _this14.showit = true;
      });
      this.current = 1;
      this.selected = 0;
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度

      this.departId = '';
      this.postList = [];
      this.mapCenter = [];
      this.loadDepartTree(); //加载部门树方法

      this.loadDefaultSuffix();
      this.loadAllTenant();
      var that = this;
      that.initialRoleList();
      that.checkedDepartNameString = '';
      that.form.resetFields();

      if (record.hasOwnProperty('id')) {
        that.loadUserRoles(record.id);
        that.loadCheckedDeparts(record.id); //加载选中的部门
        //that.loadCheckedPosts(record.id) //加载选中的岗位

        this.picUrl = 'Has no pic url yet';
      } //获取额外需要添加的字段信息


      if (that.userDepartModel.departIdList != null) {
        that.loadPostList(that.userDepartModel.departIdList[0]);
      }

      that.userId = record.id;
      this.getTreeData();
      this.loadParams();
      this.onTreeSelect();
      that.visible = true;
      that.model = Object.assign({}, record);
      that.$nextTick(function () {
        that.form.setFieldsValue(pick(_this14.model, 'id', 'username', 'sex', 'realname', 'st', 'email', 'phone', 'activitiSync', 'singlePoint'));
        window.localStorage.getItem('tenant') && window.localStorage.getItem('tenant') != 0 ? that.selectedTenant(window.localStorage.getItem('tenant'), false) : that.selectedTenant(record.tenantId, false);
      });

      if (!this.model.postId) {
        this.model.postId = undefined;
      } // 调用查询用户对应的部门信息的方法
      //that.checkedDepartKeys = []
      //that.loadCheckedDeparts()

    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        var newData = _toConsumableArray(this.paramList);

        var target = newData.find(function (item) {
          return item.code === 'center_zoom';
        });

        if (target) {
          target.val = value.toString();
          this.paramList = newData;
        }

        this.form.setFieldsValue({
          center_zoom: value.toString()
        });
      }
    },
    loadParams: function loadParams() {
      var _this15 = this;

      var pa = 'user_common_params';
      getAction(this.url.config + pa).then(function (res) {
        var paramList = JSON.parse(res.result);
        paramList.forEach(function (element) {
          element.val = '';
        });
        _this15.paramList = paramList;

        if (_this15.userId) {
          getAction(_this15.url.userParams + _this15.userId).then(function (res) {
            if (res.success) {
              var paramValue = res.result;
              paramList.forEach(function (element) {
                var param = paramValue.find(function (item) {
                  return item.code === element.code;
                });
                element.val = param == undefined ? '' : param.val;

                if (element.code == 'center_zoom') {
                  _this15.mapCenter = element.val == undefined ? [] : element.val.split(',');
                }
              });
              _this15.paramList = paramList;
            }
          });
        }
      });
    },
    loadCheckedDeparts: function loadCheckedDeparts(params) {
      var that = this;

      if (!params) {
        return;
      }

      getAction(that.url.userWithDepart, {
        userId: params
      }).then(function (res) {
        if (res.success) {
          that.departId = res.result[0].key;
          that.loadPostList(that.departId); //加载该部门下的岗位
        }
      });
    },
    // loadCheckedPosts(params) {
    //   let that = this
    //   if (!params) {
    //     return
    //   }
    //   getAction(that.url.userWithPost, { userId: params }).then(res => {
    //     if (res.success) {
    //       let postList = ''
    //       res.result.forEach(element => {
    //         postList.push(element.postId)
    //       })
    //       that.postId = postList
    //     }
    //   })
    // },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
      this.userDepartModel = {
        userId: '',
        departIdList: []
      };
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.checkedDepartKeys = [];
      this.selectedDepartKeys = [];
    },
    moment: moment,
    handleSubmit: function handleSubmit() {
      var _this16 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var avatar = that.model.avatar; // if (!values.birthday) {
          //   values.birthday = ''
          // } else {
          //   values.birthday = values.birthday.format(this.dateFormat)
          // }

          var formData = Object.assign(_this16.model, values);
          formData.userSiteIds = _this16.checkedKeys.length > 0 ? _this16.checkedKeys.join(',') : '';
          formData.lastUserSiteIds = _this16.lastUserSiteIds.length > 0 ? _this16.lastUserSiteIds.join(',') : '';
          formData.avatar = avatar;
          formData.selectedroles = _this16.selectedRole.length > 0 ? _this16.selectedRole.join(',') : ''; // formData.selecteddeparts = this.userDepartModel.departIdList.length > 0 ? this.userDepartModel.departIdList.join(',') : ''

          formData.selecteddeparts = _this16.departId; // that.addDepartsToUser(that,formData); // 调用根据当前用户添加部门信息的方法

          formData.params = _this16.paramList;
          var obj;
          console.log(_this16.model.id == undefined);

          if (_this16.model.id == undefined) {
            formData.id = _this16.userId;
            obj = addUser(formData);
          } else {
            obj = editUser(formData);
          }

          obj.then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
            that.checkedDepartNames = [];
            that.userDepartModel.departIdList = {
              userId: '',
              departIdList: []
            };
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      var form = this.form;
      var confirmpassword = form.getFieldValue('confirmpassword');

      if (value && confirmpassword && value !== confirmpassword) {
        callback('两次输入的密码不一样！');
      }

      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], {
          force: true
        });
      }

      callback();
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;

      if (value && value !== form.getFieldValue('password')) {
        callback('两次输入的密码不一样！');
      } else {
        callback();
      }
    },
    validatePhone: function validatePhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'phone',
            fieldVal: value,
            dataId: this.userId
          };
          duplicateCheck(params).then(function (res) {
            if (res.success) {
              callback();
            } else {
              callback('手机号已存在!');
            }
          });
        } else {
          callback('请输入正确格式的手机号码!');
        }
      }
    },
    validateEmail: function validateEmail(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'email',
            fieldVal: value,
            dataId: this.userId
          };
          duplicateCheck(params).then(function (res) {
            if (res.success) {
              callback();
            } else {
              callback('邮箱已存在!');
            }
          });
        } else {
          callback('请输入正确格式的邮箱!');
        }
      }
    },
    validateUsername: function validateUsername(rule, value, callback) {
      var params = {
        tableName: 'sys_user',
        fieldName: 'username',
        fieldVal: value,
        dataId: this.userId
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback('用户名已存在!');
        }
      });
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    normFile: function normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }

      return e && e.fileList;
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success) {
          this.model.avatar = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.model.avatar;
    },
    // 搜索用户对应的部门API
    onSearch: function onSearch() {
      this.$refs.departWindow.add(this.checkedDepartKeys, this.userId);
    },
    // 获取用户对应部门弹出框提交给返回的数据
    modalFormOk: function modalFormOk(formData) {
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.checkedDepartNameString = '';
      this.userId = formData.userId;
      this.userDepartModel.userId = formData.userId;

      for (var i = 0; i < formData.departIdList.length; i++) {
        this.selectedDepartKeys.push(formData.departIdList[i].key);
        this.checkedDepartNames.push(formData.departIdList[i].title);
        this.checkedDepartNameString = this.checkedDepartNames.join(',');
      }

      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    },
    loadDefaultSuffix: function loadDefaultSuffix() {
      var that = this;
      getAction(this.url.queryDefaultSuffix).then(function (res) {
        if (res.success) {
          that.defaultSuffix = '默认密码 用户名' + res.result + '（无需设置）';
        }
      });
    }
  }
};